document.addEventListener('DOMContentLoaded', () => {
  // 给所有 .tab-item 绑定点击事件
  document.querySelectorAll('.tab-item').forEach(tab => {
    tab.addEventListener('click', () => {
      const filter = tab.dataset.filter;
      const checkboxId = tab.dataset.label;
      const checkbox = document.getElementById(checkboxId);

      if (!filter) {
        if (checkbox) {
          checkbox.click(); // 模拟点击 checkbox
        } else {
          console.error(`Can't Fine checkbox with id ${checkboxId}`);
        }
      }
    });
  });

  // 同步 checkbox 状态到 tab 的函数
  function syncInitialCheckboxStates() {
    const container = document.querySelector('.tab-filter .container');
    const firstActive = container?.dataset.firstActive === 'true';
    const checkboxes = document.querySelectorAll('#FacetsWrapperDesktop input[type="checkbox"]');
    const firstTabItem = document.querySelector('.tab-item');

    // 同步所有 checkbox 状态到对应 tab 的 active 类
    checkboxes.forEach(checkbox => {
      const tabItem = document.querySelector(`.tab-item[data-label="${checkbox.id}"]`);
      if (tabItem) {
        tabItem.classList.toggle('active', checkbox.checked);
      }
    });

    if (firstActive && firstTabItem) {
      const hasAnyChecked = Array.from(checkboxes).some(cb => cb.checked);

      if (hasAnyChecked) {
        firstTabItem.classList.remove('active');
      } else {
        firstTabItem.classList.add('active');
      }
    }
  }

  // 页面加载时初始化同步状态
  syncInitialCheckboxStates();

  // 监听 #FacetsWrapperDesktop 变化，重新同步状态
  const targetNode = document.getElementById('FacetsWrapperDesktop');
  if (targetNode) {
    const observer = new MutationObserver(() => {
      syncInitialCheckboxStates();
    });
    observer.observe(targetNode, { childList: true, subtree: true });
  }
});